import { CampaignServiceEditorInitData } from '../actions/campaignServiceEditor/initCampaignServiceEditors';
import { getCampaignServiceEditorId } from '../service/CampaignsEditHelpers/CampaignsEditHelpers';
import { EditCampaignData, EditCampaignValueField } from '../typings/campaignsEdit';
import { CampaignId } from '../typings/domain';

export function mapCampaignsDataForEditToInitServiceData(
    campaigns: Record<CampaignId, EditCampaignData>
): CampaignServiceEditorInitData[] {
    return Object.keys(campaigns).map(
        (campaignId: CampaignId): CampaignServiceEditorInitData => {
            const value = campaigns[campaignId].value[EditCampaignValueField.service];

            return {
                editorId: getCampaignServiceEditorId(campaignId),
                service: {
                    serviceId: value.serviceId,
                    isMobile: value.isMobile
                }
            };
        }
    );
}
